import { render, staticRenderFns } from "./timeBox.vue?vue&type=template&id=0df45f03&scoped=true"
import script from "./timeBox.vue?vue&type=script&lang=js"
export * from "./timeBox.vue?vue&type=script&lang=js"
import style0 from "./timeBox.vue?vue&type=style&index=0&id=0df45f03&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df45f03",
  null
  
)

export default component.exports